import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../components/shared/Layout/Layout";
import moment from "moment";
import { toast } from "react-toastify";
import API from "../../services/API";
import { useSelector } from "react-redux";

const Organisation = () => {
  const [data, setData] = useState([]);
  const { user } = useSelector((state) => state.auth);

  const getOrg = useCallback(async () => {
    try {
      if (user?.role === "donar") {
        const { data } = await API.get("/inventory/get-organisation");
        if (data?.success) {
          setData(data?.organisations);
        }
      }

      if (user?.role === "hospital") {
        const { data } = await API.get(
          "/inventory/get-organisation-for-hospital"
        );
        if (data?.success) {
          setData(data?.organisations);
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  }, [user?.role]);

  useEffect(() => {
    getOrg();
  }, [getOrg]);

  return (
    <Layout>
      <h3 className="mx-auto hospital-heading">
        Organisation Details{" "}
        <i className="fa-solid fa-building-ngo" style={{ color: "#ffffff" }} />
      </h3>
      <div className="container">
        <div className="container donar-data">
          <table className="table table-hover">
            <thead>
              <tr className="heading-fixed">
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                <th scope="col">Address</th>
                <th scope="col">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((record) => (
                <tr key={record._id}>
                  <td>{record.organisationName}</td>
                  <td>{record.email}</td>
                  <td>{record.phone}</td>
                  <td>{record.address}</td>
                  <td>
                    {moment(record.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Organisation;
